module.exports = __webpack_public_path__ + "img/green-1.4cfb5880.svg";